import { activeGameId } from "../../util/selectors";
import { getSafe } from "../../util/storeHelper";
import { SITE_ID } from "./constants";
import { createCachedSelector } from "re-reselect";
import { createSelector } from "reselect";
export function knownGames(state) {
    return state.session.gameMode.known ?? [];
}
export function discovered(state) {
    return state.settings.gameMode.discovered;
}
export const currentGame = createSelector(knownGames, activeGameId, (games, currentGameMode) => games.find((game) => game.id === currentGameMode));
export const gameById = createCachedSelector(knownGames, (state, gameId) => gameId, (games, gameId) => games.find((game) => game.id === gameId))((state, gameId) => gameId);
/**
 * return the discovery information about a game
 *
 * @export
 * @param {*} state
 * @returns {IDiscoveryResult}
 */
export function currentGameDiscovery(state) {
    const gameMode = activeGameId(state);
    return getSafe(state, ["settings", "gameMode", "discovered", gameMode], undefined);
}
export const discoveryByGame = createCachedSelector(discovered, (state, gameId) => gameId, (discoveredIn, gameId) => discoveredIn[gameId])((state, gameId) => gameId);
export function gameName(state, gameId) {
    if (gameId === SITE_ID) {
        return "Tools & Extensions";
    }
    const fromDiscovery = getSafe(state, ["settings", "gameMode", "discovered", gameId, "name"], undefined);
    if (fromDiscovery !== undefined) {
        return fromDiscovery;
    }
    const known = getSafe(state, ["session", "gameMode", "known"], []).find((game) => game.id === gameId);
    if (known !== undefined) {
        return known.name;
    }
    else {
        return undefined;
    }
}
